import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import "./addEval.css";
import iconLeftArrow from "../../../assets/images/icon-left-arrow.png";
import {
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import iconChat from "../../../assets/images/icon-chat.svg";
import iconInfo from "../../../assets/images/icon-info.svg";
import {
  getOneGrilles,
  HandelGrille,
  ClearGrille,
} from "../../../redux/actions/grille";
import "react-datepicker/dist/react-datepicker.css";
import LeftSide from "./LeftSide";
import { createEval } from "../../../redux/actions/evaluation";
import Popover1 from "../Popover";
import Alert from "../../../components/Alert/Alert";
import PopoverBonus from "./PopoverBonus";
import Popovermalus from "./Popovermalus";

const AddEval = (props) => {
  const history = useHistory();
  //const { user } = useAuth0();
  const user = JSON.parse(localStorage.getItem("user"));

  const { datagrilleselecet } = useSelector(
    (state) => state.grille
  );
  const {
    selectedBMselectedmalus1,
    selectedBMselectedbonus1,
  } = useSelector((state) => state.design);
  const { dataeval } = useSelector((state) => state.evaluation);

  let val = window.location.search;
  let pathChoice = val.substring(val.indexOf("=") + 1);
  const location = useLocation();
  const dup = location?.state?.dup;

 
  const [colorParam, setColorParam] = useState({
    id: 0,
    idg: 0,
    color: null,
    name: null,
    comment: null,
  });
  const [displayParam, setDisplayParam] = useState({
    statuse: false,
    idc: 0,
    idg: 0,
  });
  const [data, setData] = useState(
    dup
      ? dataeval.eval
      : {
          note: 0,
          dateInteraction: "",
          gridId: pathChoice ? pathChoice : 0,
          agentId: 0,
          evaluateurId: 0,
          DetailEval: [],
          attributs: [],
          ScoreGroupCriteriaEval : []
          //attributeValueIDs: [],
        }
  );

  const [openCallibrage, setOpenCallibrage] = useState(false);
  const [displayInfoBar, setDisplayInfoBar] = useState({
    displayInfoBar: false,
    id: 0,
  });

  const [isOpenComment, setIsOpenComment] = useState({
    displayOpenComment: false,
    id: 0,
  });
  const [sum, setSum] = useState({});
  const [testSum, setTestSum] = useState([]);
  const [total, setTotal] = useState(0);
  const [comment, setcomment] = useState([]);
  const [countCriteriaGroup , setCountCriteriaGroup]= useState(0);
  const [countNbrCriteria , setCountNbrCriteria] = useState(0);
  const [showmessage , setShowmessage] = useState(false);
  const [showAgentmessage , setShowAgentmessage] = useState(false);
  const [showDatemessage , setShowDatemessage] = useState(false);


  const [sume, setSume] = useState({});
  const [statuse, setStatuse] = useState({});
  const [statusgc, setStatusgc] = useState({});
  const [color, setColor] = useState({});
  const [selectionOption, setSelectionOption] = useState([]);
  const [selectionOptionMalus, setSelectionOptionMalus] = useState([]);

  const [countoptions, setCountoptions] = useState([
    {
      count: 0,
      idC: 0,
      idOption: 0,
    },
  ]);
  const [displayCount, setDisplayCount] = useState(false);
  const [countoptionsMalus, setCountoptionsMalus] = useState([
    {
      count: 0,
      idC: 0,
      idOption: 0,
    },
  ]);
  const [displayCountMalus, setDisplayCountMalus] = useState(false);
  const [crId, setCrId] = useState();
  const [dataComment, setDataComment] = useState();
  const [totalCoef, setTotalCoef] = useState(0);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ClearGrille());
    setData({
      ...data,
      evaluateurId: JSON.parse(localStorage.getItem("user"))?.id,
    });
  }, []);
 

 

  useEffect(() => {
    console.log("datagrilleselecet",
    datagrilleselecet);

    setCountCriteriaGroup(datagrilleselecet?.grid?.CriteriaGroup?.length);

    const CountCriteria = datagrilleselecet?.grid?.CriteriaGroup?.reduce((acc, item) => {
      return acc + item.Criteria.length;
    }, 0);
    setCountNbrCriteria(CountCriteria);

  }, [datagrilleselecet]);

  const closeCallibrage = () => {
    setTimeout(() => {
      setOpenCallibrage(false);
    }, 2000);
  };
  let result = 0;
  let countCoef = 0;
  // let finalSumResult
  let array = [];
  let arrayTotal = [];
  let TotalCoef = [];
  var SumTotal = 0;
  let NAArr = [];

  const addBonusOrMalustoScore = (initialScore, optionScore) => {
    let finalScore = initialScore;

    optionScore.forEach((element) => {
      if (element.type === "BONUS" && finalScore < 100) {
        finalScore = finalScore + element.score;
      }
      if (element.type === "MALUS" && finalScore > 0) {
        finalScore = finalScore - element.score;
      }
    });

    if (finalScore > 100) {
      finalScore = 100;
    } else if (finalScore < 0) {
      finalScore = 0;
    }

    return finalScore;
  };

  const getSelectionOptionMalus = (option) => {
    let listCriteriaIds;
    let matchedValues = [];

    setSelectionOptionMalus([...selectionOptionMalus, option]);
    const CountOption = countoptionsMalus
      ?.filter((c) => c.idC == option.CriterionId)
      .map((c) => c.count);

    setCountoptionsMalus([
      ...countoptionsMalus?.filter((c) => c.idC !== option.CriterionId),
      {
        count:
          CountOption && CountOption.length > 0
            ? Number(CountOption[0]) + 1
            : 1,
        idC: option.CriterionId,
        idOption: option.id,
      },
    ]);

    setDisplayCountMalus(true);

    if (data.DetailEval && data.DetailEval.length) {
      const DatEval = data?.DetailEval.map((d) => {
        if (d?.CriterionId == option?.CriterionId) {
          matchedValues.push(option?.CriterionId);
          setData({
            ...data,
            DetailEval: [
              ...data.DetailEval?.filter(
                (d) => d.CriterionId !== option?.CriterionId
              ),
              {
                value: d?.value,
                comment: d?.comment,
                criteriaOptionValueIDs: [
                  ...d?.criteriaOptionValueIDs.filter((i) => i !== option.id),
                  option.id,
                ],
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(option.CriterionId)) {
            setData({
              ...data,
              DetailEval: [
                ...data.DetailEval,
                {
                  value: "",
                  comment: "",
                  criteriaOptionValueIDs: [option.id],
                  CriterionId: option.CriterionId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: "",
            criteriaOptionValueIDs: [option.id],
            CriterionId: option.CriterionId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }

    const selectoption = selectionOptionMalus?.forEach((element) => {
      if (element.id === option.id) {
        setSelectionOptionMalus(
          selectionOptionMalus.filter((element) => element?.id !== option.id)
        );

        setCountoptionsMalus([
          ...countoptionsMalus?.filter((c) => c.idC !== option.CriterionId),
          {
            count:
              CountOption &&
              CountOption.length > 0 &&
              Number(CountOption[0]) - 1,
            idC: option.CriterionId,
            idOption: option.id,
          },
        ]);

        //Eliminate the unselected criteriaoptions from criteriaOptionValueIDs List:
        const FiltredList = data.DetailEval.map((d) => {
          if (d.criteriaId == option.criteriaId) {
            listCriteriaIds = d;
          }
        });
        const criteriaIdsList = listCriteriaIds.criteriaOptionValueIDs.filter(
          (c) => c !== option.id
        );
        listCriteriaIds.criteriaOptionValueIDs = criteriaIdsList;
        setData({
          ...data,
          DetailEval: [
            ...data.DetailEval?.filter(
              (d) => d.CriterionId !== option?.CriterionId
            ),
            listCriteriaIds,
          ],
        });
      }
    });
  };
  const getSelectionOption = (option) => {
    let listCriteria;
    let matchedValues = [];

    setSelectionOption([...selectionOption, option]);

    const CountOption = countoptions
      ?.filter((c) => c.idC == option.CriterionId)
      .map((c) => c.count);

    setCountoptions([
      ...countoptions?.filter((c) => c.idC !== option.CriterionId),
      {
        count:
          CountOption && CountOption.length > 0
            ? Number(CountOption[0]) + 1
            : 1,
        idC: option.CriterionId,
        idOption: option.id,
      },
    ]);

    setDisplayCount(true);

    if (data.DetailEval && data.DetailEval.length) {
      const dataEval = data?.DetailEval.map((d) => {
        if (d?.CriterionId == option?.CriterionId) {
          matchedValues.push(option?.CriterionId);
          setData({
            ...data,
            DetailEval: [
              ...data.DetailEval?.filter(
                (d) => d.CriterionId !== option?.CriterionId
              ),
              {
                value: d?.value,
                comment: d?.comment,
                criteriaOptionValueIDs: [
                  ...d?.criteriaOptionValueIDs.filter((i) => i !== option.id),
                  option.id,
                ],
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(option.CriterionId)) {
            setData({
              ...data,
              DetailEval: [
                ...data.DetailEval,
                {
                  value: "",
                  comment: "",
                  criteriaOptionValueIDs: [option.id],
                  CriterionId: option.CriterionId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: "",
            criteriaOptionValueIDs: [option.id],
            CriterionId: option.CriterionId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }

    const selectoption = selectionOption?.forEach((element) => {
      if (element.id === option.id) {
        setSelectionOption(
          selectionOption.filter((element) => element?.id !== option.id)
        );

        setCountoptions([
          ...countoptions?.filter((c) => c.idC !== option.CriterionId),
          {
            count:
              CountOption &&
              CountOption.length > 0 &&
              Number(CountOption[0]) - 1,
            idC: option.CriterionId,
            idOption: option.id,
          },
        ]);

        //Eliminate the unselected criteriaoptions from criteriaOptionValueIDs List:
        data.DetailEval.map((d) => {
          if (d.criteriaId == option.criteriaId) {
            listCriteria = d;
          }
        });
        const criteriaIdsList = listCriteria.criteriaOptionValueIDs.filter(
          (c) => c !== option.id
        );
        listCriteria.criteriaOptionValueIDs = criteriaIdsList;
        setData({
          ...data,
          DetailEval: [
            ...data.DetailEval?.filter(
              (d) => d.CriterionId !== option?.CriterionId
            ),
            listCriteria,
          ],
        });

        // setCountoptions(countoptions - 1);
      }
    });
  };

  function getSomme(countCriteria, column, criteriaGroupeID, option) {

    array = column.filter(
      (thing, index, self) => index === self.findIndex((t) => t.id === thing.id)
    );
   
    array = array.filter(
      (obj, index) => obj.criteriaGroupeID === criteriaGroupeID
    );
   
     
    array = array.filter((obj, index) => obj.impactant     === true );
    NAArr = array.filter((obj, index) => obj.NonApplicable === true);
    array = array.filter((obj, index) => obj.NonApplicable === false);

    //eliminer les Critères Non Applicables.
    if(NAArr){
      countCriteria -=  NAArr.length;
    }
   
    if (array.length !== 0) {
      result = array?.reduce(function (a, b) {
        // console.log('score a :', a.score,' coef a :', a.coefficient, 'score b:', b.score, 'coef b :',  b.coefficient);
        return {
          score:
            a.score * (a.coefficient === undefined ? 1 : a.coefficient) +
            b.score * b.coefficient,
        };
      });

      countCoef = array?.reduce(function (a, b) {
        return { coefficient: a.coefficient + b.coefficient };
      });

      if (array.length === countCriteria) {
        arrayTotal = [
          ...arrayTotal,
          result.score / 100,
          // result.score /
          //   countCoef.coefficient,
        ];
        TotalCoef = [...TotalCoef, countCoef.coefficient];
       
        console.log(
          "round==",
          Math.round(result.score / countCoef.coefficient),
          result.score,
          countCoef.coefficient
        );

        if(data.ScoreGroupCriteriaEval.map((e) => e.GroupCriteriaId).includes(criteriaGroupeID)){

          data.ScoreGroupCriteriaEval = [
            ...data.ScoreGroupCriteriaEval.filter((item)=> item.GroupCriteriaId !== criteriaGroupeID),
            {
              GroupCriteriaId: criteriaGroupeID ,
              score : Math.round((result.score /countCoef.coefficient))
             }
          ]
        }
        else{
          data.ScoreGroupCriteriaEval.push({
            GroupCriteriaId: criteriaGroupeID ,
            score : Math.round((result.score /countCoef.coefficient))
           })
        }

        return (
          Math.round((result.score /countCoef.coefficient)) 
        );
      }
    }
  }

useEffect(()=>{
  SumTotal = getSommeTotal(arrayTotal,TotalCoef);
  setTotal(SumTotal);
},[arrayTotal,TotalCoef])

  function getSommeTotal(arrayTotal,TotalCoef) {
  
    const initialValue = 0;
    const sumWithInitial = arrayTotal.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      initialValue
    );

    const SumCoef = TotalCoef.reduce(
      (prevValue, currentValue) => prevValue + currentValue,
      initialValue
    );

    SumTotal = Math.round(sumWithInitial * 100) / 100 / SumCoef;
    SumTotal = Math.round(SumTotal * 100);

    if (arrayTotal.length === countCriteriaGroup) {
      if (SumTotal < 100 && selectionOption) {
        SumTotal = addBonusOrMalustoScore(SumTotal, selectionOption);
      }
      if (SumTotal > 0 && selectionOptionMalus) {
        SumTotal = addBonusOrMalustoScore(SumTotal, selectionOptionMalus);
      }

      return SumTotal;
    }

    return SumTotal;
  }

  const handelchangeDescription = (e) => {
    // if (e.key === "Enter") {
    //   console.log('entrer')

    let CriteriaComment;
    let matchedValues = [];

    comment?.map((c) => {
      if (c?.criteriaId == crId) {
        CriteriaComment = c?.comment;
        return CriteriaComment;
      }
    });

    if (data?.DetailEval && data?.DetailEval?.length) {
      data?.DetailEval?.map((d) => {
        if (d?.CriterionId == crId) {
          matchedValues.push(crId);
          setData({
            ...data,
            DetailEval: [
              ...data?.DetailEval.filter((d) => d?.CriterionId !== crId),
              {
                value: d?.value,
                comment: CriteriaComment,
                criteriaOptionValueIDs: d?.criteriaOptionValueIDs,
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(crId)) {
            setData({
              ...data,
              DetailEval: [
                ...data?.DetailEval,
                {
                  value: "",
                  comment: CriteriaComment,
                  criteriaOptionValueIDs: [],
                  CriterionId: crId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: CriteriaComment,
            criteriaOptionValueIDs: [],
            CriterionId: crId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }
    annuler();
  };

  const showDescription = (id) => {
    setCrId(id);
    for (var i = 0; i < comment.length; i++) {
      if (comment[i]?.criteriaId == id) {
        setDataComment(comment[i]?.comment);
        break;
      } else {
        setDataComment("");
      }
    }
  };

  const handelbonu = (id) => {
    let filtere = (
      dup ? datagrilleselecet.CriteriaGroup : datagrilleselecet.CriteriaGroup
    ).filter((e) => e.id === id);

    let array =
      filtere[0]?.Criteria && filtere[0]?.Criteria.map((e) => e.CriteriaOption);

    let array2 =
      filtere[0]?.Criteria &&
      filtere[0]?.Criteria.map(
        (e) => e.CriteriaOption && e.CriteriaOption.map((e) => e)
      );
    let name = array2;
    let content = array[0];
    return { content, name };
  };

  const handelChangeagentId = (id) => {
    setData({ ...data, agentId: id });
  };

  const annuler = () => {
    
    isOpenComment.displayOpenComment = !isOpenComment.displayOpenComment;
    setIsOpenComment({ ...isOpenComment });
    
  };
  const annulerComment = () => {
    isOpenComment.displayOpenComment = !isOpenComment.displayOpenComment;
    setIsOpenComment({ ...isOpenComment });
    if (data?.DetailEval && data?.DetailEval?.length) {
      data?.DetailEval?.map((d) => {
        if (d?.CriterionId == crId) {
          const previousComment = data?.DetailEval.filter(
            (d) => d?.CriterionId === crId
          )[0].comment;
          const updatedComments = comment.map((c) => {
            if (c?.criteriaId === crId) {
              return {
                ...c,
                comment: previousComment,
              };
            }
            return c;
          });
          setcomment(updatedComments);
          setDataComment(previousComment);
        } else {
          const updatedComments = comment.filter((c) => c?.criteriaId !== crId);
          setcomment(updatedComments);
          setDataComment("");
        }
      });
    } else {
      const updatedComments = comment.filter((c) => c?.criteriaId !== crId);
      setcomment(updatedComments);
      setDataComment("");
    }
  };
  const handelChangeattributId = (attributs) => {
    setData({ ...data, attributs: attributs });
  };


  const handelChangegrilletId = (id) => {
    setData({ ...data, gridId: id });
  };
  const handelChangedate = (date) => {
    setData({ ...data, dateInteraction: date });
  };
  const [isSaving, setIsSaving] = useState(false);
  const handleSubmit = (event) => {
    console.log("data",data);
    
    if(data.DetailEval.length == countNbrCriteria){
      setShowmessage(false);
if(data.agentId!=0){
  setShowAgentmessage(false)
  if(data.dateInteraction!=""){
 setShowDatemessage(false)
     
      setIsSaving(true);
      data.note = total;
      data.TenantId = user?.TenantId;
      event.preventDefault();
      dispatch(createEval(data))
        .then(() => {
          setDisplay("block");
          setTimeout(() => {
            history.push("quality-monitoring");
          }, 3000);
        })
        .catch(() => {
          setDisplay("block");
          setIsSaving(false);
        });}else{
          setDisplay("block");
          setShowDatemessage(true);
        }
      
      
      
      }
        
        else{
          setDisplay("block");
          setShowAgentmessage(true);
        }
    }else {
      setDisplay("block");
      setShowmessage(true);
    }
    
  };

  const changeComment = (option) => {
    setcomment([
      ...comment?.filter((c) => c.criteriaId !== crId),
      { comment: option.target.value, criteriaId: crId },
    ]);
    setDataComment(option.target.value);
  };

  function isObjEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }

    return true;
  }

  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className="textarea-comment"
        as="textarea"
        rows={3}
        value={dataComment && dataComment}
        onChange={(e) => {
          changeComment(e);
        }}
        // onKeyDown={handelchangeDescription}
      />
      <div className="buttons-of-textarea-comment">
        <span style={{ color: "#B7B7B7", cursor: "pointer" }} onClick={annulerComment}>
          Annuler
        </span>
        <span
          style={{ color: "#5800e2", cursor: "pointer" }}
          onClick={handelchangeDescription}
        >
          Ajouter
        </span>
      </div>
    </Tooltip>
  );
  const { message, status } = useSelector((state) => state.message);
  const [display, setDisplay] = useState("none");
  const onDisplay = (display) => {
    setDisplay(display);
  };

  return (
    <>
      <div id="nouvelle-eval-body">

        {openCallibrage ? (
          <Callibrage
            openCallibrage={openCallibrage}
            closeCallibrage={closeCallibrage}
          />
        ) : null}
        <div id="nouvelle-eval-bar">
          <div className="div-bar">
            <div
              onClick={() => {
                displayInfoBar.displayInfoBar = false;
                setDisplayInfoBar({ ...displayInfoBar });
                dispatch(HandelGrille({}));
                history.goBack();
              }}
              className="container-icon-arraw-left"
            >
              <img src={iconLeftArrow} width="20" height="20" />
            </div>
            <h5 className="add-eval-title" style={{ marginBottom: "0" }}>
              {" "}
              Nouvelle évaluation{" "}
            </h5>
          </div>
          <div className="div-bar">
            <div style={{ color: "#B7B7B7", fontFamily: "Gilroy-Semibold" }}>
              Score Total :
            </div>
            <div className="input-score">
              {isNaN(total) || total === undefined ? <span> 0 </span> : total}
</div>
          </div>
        </div>

        <div id="nouvelle-eval-under-bare" className="align-divs-horizental">
          <div id="nouvelle-eval-left-side">
            <LeftSide
              handelChangeagentId={handelChangeagentId}
              handelChangegrilletId={handelChangegrilletId}
              handelChangedate={handelChangedate}
              handelChangeattributId={handelChangeattributId}
              data={data}
            />
          </div>
          <div
            id="nouvelle-eval-right-side"
            style={
              displayInfoBar.displayInfoBar === true
                ? { width: "65%" }
                : { width: "80%" }
            }
            className="align-divs-vertical"
          >
            <div className="container-of-right-side">
              {dup
                ? datagrilleselecet &&
                  datagrilleselecet.CriteriaGroup &&
                  datagrilleselecet.CriteriaGroup.map((gc, igc) => (
                    <div className="subcontainer-of-right-side">
                      <div className="flex-space-between">
                        <span style={{ color: "#5800e2" }}>{gc.name}</span>
                        <div className="input-score">
                          {dup
                            ? dataeval.eval.note
                            : sume[igc] !== undefined &&
                              selectedBMselectedmalus1[gc.id] !== undefined &&
                              selectedBMselectedbonus1[gc.id] !== undefined
                            ? sume[igc] +
                              selectedBMselectedmalus1[gc.id] -
                              selectedBMselectedbonus1[gc.id]
                            : sume[igc] !== undefined &&
                              selectedBMselectedmalus1[gc.id] === undefined &&
                              selectedBMselectedbonus1[gc.id] !== undefined
                            ? sume[igc] - selectedBMselectedbonus1[gc.id]
                            : sume[igc] !== undefined &&
                              selectedBMselectedmalus1[gc.id] === undefined &&
                              selectedBMselectedbonus1[gc.id] === undefined
                            ? sume[igc]
                            : sume[igc] !== undefined &&
                              selectedBMselectedmalus1[gc.id] !== undefined &&
                              selectedBMselectedbonus1[gc.id] === undefined
                            ? sume[igc] + selectedBMselectedmalus1[gc.id]
                            : sume[igc] === undefined &&
                              selectedBMselectedbonus1[gc.id] !== undefined &&
                              selectedBMselectedmalus1[gc.id] === undefined
                            ? -selectedBMselectedbonus1[gc.id]
                            : sume[igc] === undefined &&
                              selectedBMselectedbonus1[gc.id] !== undefined &&
                              selectedBMselectedmalus1[gc.id] !== undefined
                            ? selectedBMselectedmalus1[gc.id] -
                              selectedBMselectedbonus1[gc.id]
                            : sume[igc] === undefined &&
                              selectedBMselectedbonus1[gc.id] === undefined &&
                              selectedBMselectedmalus1[gc.id] !== undefined
                            ? selectedBMselectedmalus1[gc.id]
                            : 0}{" "}
                        </div>
                      </div>
                      {dataeval.CriteriaGroup[gc.name].map((c, ic) => (
                        <div className="flex-space-between containers-of-grids">
                          <div
                            onClick={() => {
                              setDisplayParam({
                                statuse: false,
                                idg: 0,
                                idc: 0,
                              });
                            }}
                            className="col-2"
                          >
                            {c.Criteria.name}
                          </div>
                          <div className="row">
                            {gc[0].Criteria?.CriteriaValue?.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map(function (
                              d,
                              idx
                            ) {
                              return (
                                <div
                                  key={idx}
                                  className="col container-sub-grid"
                                  onClick={() => {
                                    if (
                                      !data.DetailEval.map(
                                        (e) => e.CriterionId
                                      ).includes(c.id)
                                    ) {
                                      data.DetailEval.push({
                                        value: d.name,
                                        comment: "",
                                        criteriaOptionValueIDs: [],
                                        
                                        CriterionId: c.id,
                                        CriterionGroupeId: gc.id,
                                      });
                                      setData({
                                        ...data,
                                        DetailEval: [...data.DetailEval],
                                       
                                      });
                                    } else {
                                      if (igc === 0) {
                                        data.DetailEval[ic] = {
                                          value: d.name,
                                          comment: data.DetailEval[ic]?.comment,
                                          criteriaOptionValueIDs:
                                            data.DetailEval[ic]
                                              ?.criteriaOptionValueIDs,
                                         
                                          CriterionId: c.id,
                                          CriterionGroupeId: gc.id,
                                        };
                                        setData({
                                          ...data,
                                          DetailEval: [...data.DetailEval],
                                         
                                        });
                                      } else {
                                        data.DetailEval[
                                          data.DetailEval.length - 1
                                        ] = {
                                          value: d.name,
                                          comment: data.DetailEval[ic]?.comment,
                                          criteriaOptionValueIDs:
                                            data.DetailEval[ic]
                                              ?.criteriaOptionValueIDs,
                                       
                                          CriterionId: c.id,
                                          CriterionGroupeId: gc.id,
                                        };
                                        setData({
                                          ...data,
                                          DetailEval: [...data.DetailEval],
                                        
                                        });
                                      }
                                    }

                                    setColorParam({
                                      id: d.id,
                                      color: d.color,
                                      name: d.name,
                                      value: d.score,
                                      comment: d.description,
                                    });
                                    setDisplayParam({
                                      statuse: !displayParam.status,
                                      idc: c.id,
                                      idg: gc.id,
                                    });
                                    !statuse[d.id]
                                      ? c.CriteriaValue.slice(
                                          0,
                                          idx + 1
                                        ).forEach((item, key) => {
                                          statuse[item.id] = true;
                                          color[item.id] = d.color;
                                        })
                                      : c.CriteriaValue.slice(idx + 1).forEach(
                                          (item, key) => {
                                            statuse[item.id] = false;
                                            color[item.id] = "none";
                                          }
                                        );

                                    setStatuse({ ...statuse });
                                    setColor({ ...color });

                                    statusgc[c.id] = d.score;
                                    c.CriteriaValue.slice(0, idx + 1).forEach(
                                      (item, key) => {
                                        statuse[item.id] = true;
                                        color[item.id] = d.color;
                                      }
                                    );
                                    setColor({ ...color });
                                    setStatusgc({ ...statusgc });

                                    if (sum[igc]) {
                                      if (
                                        gc?.Criteria?.map((e) => e.id).length >
                                        1
                                      ) {
                                        for (
                                          let i = 1;
                                          i <
                                          gc?.Criteria?.map((e) => e.id).length;
                                          i++
                                        ) {
                                          if (
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[i]
                                            ]
                                          ) {
                                            sum[igc] =
                                              statusgc[
                                                gc?.Criteria?.map(
                                                  (e) => e.id
                                                )[0]
                                              ] +
                                              statusgc[
                                                gc?.Criteria?.map((e) => e.id)[
                                                  i
                                                ]
                                              ];
                                          } else {
                                            sum[igc] =
                                              statusgc[
                                                gc?.Criteria?.map(
                                                  (e) => e.id
                                                )[0]
                                              ];
                                          }
                                        }
                                      } else {
                                        if (
                                          statusgc[
                                            gc?.Criteria?.map((e) => e.id)[1]
                                          ]
                                        ) {
                                          sum[igc] =
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[0]
                                            ] +
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[1]
                                            ];
                                        } else {
                                          sum[igc] =
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[0]
                                            ];
                                        }
                                      }
                                    } else {
                                      sum[igc] = statusgc[c.id];
                                    }

                                    setSum({ ...sum });

                                    sume[igc] = sum[igc];
                                    setSume({ ...sume });
                                  }}
                                >
                                  <span>{d.name}</span>

                                  {statuse[d.id] ? (
                                    <div
                                      style={{ backgroundColor: color[d.id] }}
                                      className="bar"
                                    ></div>
                                  ) : dup ? (
                                    <div
                                      style={{
                                        backgroundColor:
                                          c?.CriteriaValue[
                                            c.CriteriaValue.length - 1
                                          ].color,
                                      }}
                                      className="bar"
                                    ></div>
                                  ) : (
                                    <div className="bar"></div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          <div className="row right-icons">
                            <div className="col margin-left-right">
                              <div className="flex-space-between container-cercle-like">
                                {" "}
                                {handelbonu(gc.id).name[ic] &&
                                handelbonu(gc.id)
                                  .name[ic].map((e) => e)
                                  .filter((e) => e.name === "Bonus")[0]
                                  ?.CriteriaOptionValue.length !== undefined
                                  ? handelbonu(gc.id)
                                      .name[ic].map((e) => e)
                                      .filter((e) => e.name === "Bonus")[0]
                                      ?.CriteriaOptionValue.length
                                  : 0}{" "}
                              </div>
                              <Popover1
                                handelbonu={handelbonu}
                                gc={gc}
                                ic={ic}
                                c={c}
                              />
                            </div>
                            <div className="col margin-left-right">
                              <div className="container-cercle-dislike">
                                {" "}
                                {handelbonu(gc.id).name[ic] &&
                                handelbonu(gc.id)
                                  .name[ic].map((e) => e)
                                  .filter((e) => e.name === "Malus")[0]
                                  ?.CriteriaOptionValue.length !== undefined
                                  ? handelbonu(gc.id)
                                      .name[ic].map((e) => e)
                                      .filter((e) => e.name === "Malus")[0]
                                      ?.CriteriaOptionValue.length
                                  : 0}{" "}
                              </div>
                              <Popovermalus
                                handelbonu={handelbonu}
                                gc={gc}
                                ic={ic}
                                c={c}
                              />
                            </div>
                            {isOpenComment.displayOpenComment &&
                            isOpenComment.id === ic ? (
                              <>
                                <div className="col margin-left-right">
                                  <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="bottom-end"
                                    // overlay={popover}
                                  >
                                    <img
                                      className="img-chat-position"
                                      // width={20}
                                      src={iconChat}
                                      onClick={() => {
                                        setIsOpenComment({
                                          displayOpenComment: false,
                                          id: ic,
                                        });
                                        setCrId("");
                                      }}
                                    />
                                  </OverlayTrigger>
                                </div>
                              </>
                            ) : (
                              <div className="col margin-left-right">
                                <OverlayTrigger
                                  trigger="click"
                                  rootClose
                                  placement="bottom-end"
                                  overlay={popover}
                                >
                                  <img
                                    className="img-chat-position"
                                    // width={20}
                                    src={iconChat}
                                    onClick={() => {
                                      setIsOpenComment({
                                        displayOpenComment: false,
                                        id: ic,
                                      });
                                      //  setCrId(c?.id);
                                      showDescription(c?.id);
                                    }}
                                  />
                                </OverlayTrigger>
                              </div>
                            )}

                            <div
                              onClick={() => {
                                displayInfoBar.displayInfoBar =
                                  !displayInfoBar.displayInfoBar;
                                displayInfoBar.id = ic;
                                displayInfoBar.idg = igc;
                                setDisplayInfoBar({ ...displayInfoBar });
                                dispatch(getOneGrilles(datagrilleselecet?.grid?.id));
                              }}
                              // style={{ backgroundColor: "#FAFAFA" }}
                              className="col container-of-icon margin-left-right"
                            >
                              <img
                                className="img-chat-position"
                                // width={25}
                                src={iconInfo}
                              />
                            </div>
                          </div>
                      
                        </div>
                      ))}
                    </div>
                  ))
                : datagrilleselecet?.grid?.CriteriaGroup &&
                  datagrilleselecet.grid.CriteriaGroup.map((gc, igc) => (
                    <div className="subcontainer-of-right-side">
                      {/* <pre><code>{JSON.stringify(gc)}</code> </pre> */}
                      <div
                        className="flex-space-between"
                        style={{ paddingLeft: 5 }}
                      >
                        <span className="groupe-crit_name">{gc.name}</span>
                        <div className="input-score_critere-gr">
                          {getSomme(
                            gc.Criteria.filter(
                              (obj, index) => obj.impact === true 
                            ).length,
                            testSum,
                            gc.id,
                            selectionOption
                          )}
                        </div>
                      </div>
                      {gc?.Criteria?.map((c, ic) => (
                        <div className="row containers-of-grids align-items-center">
                          <div
                            className="col-2"
                            onClick={() => {
                              setDisplayParam({
                                statuse: false,
                                idg: 0,
                                idc: 0,
                              });
                            }}
                          >
                            {c.name}
                          </div>
                          <div className="col d-flex">
                            {c?.CriteriaValue?.sort((a,b) => {return (a.idCriteriaValue - b.idCriteriaValue)}).map(function (d, idx) {
                              return (
                                <div
                                  key={idx}
                                  className="container-sub-grid"
                                  onClick={() => {
                                    if (
                                      !data.DetailEval.map(
                                        (e) => e.CriterionId
                                      ).includes(c.id)
                                    ) {
                                      console.log('name==',d.name, typeof(d.name))
                                      data.DetailEval.push({
                                        value: d.name,
                                        score: d.score,
                                        color: d.color,
                                        comment: "",
                                        criteriaOptionValueIDs: [],
                                        // criteriaOptionValueIDs: `[{id:${
                                        //   idx + 1
                                        // }}]`,
                                        CriterionId: c.id,
                                        CriterionGroupeId: gc.id,
                                      });
                                      setData({
                                        ...data,
                                        DetailEval: [...data.DetailEval],
                                        // attributeIDs: "",
                                        // attributeValueIDs: "",
                                      });
                                    } else {
                                      if (igc === 0) {
                                        data.DetailEval[ic] = {
                                          value: d.name,
                                          score: d.score,
                                          color: d.color,
                                          comment: data.DetailEval[ic]?.comment,
                                          criteriaOptionValueIDs:
                                            data.DetailEval[ic]
                                              ?.criteriaOptionValueIDs,
                                          CriterionId: c.id,
                                          CriterionGroupeId: gc.id,
                                        };
                                        setData({
                                          ...data,
                                          DetailEval: [...data.DetailEval],
                                          // attributeIDs: "",
                                          // attributeValueIDs: "",
                                        });
                                      } else {
                                        data.DetailEval[
                                          data.DetailEval.length - 1
                                        ] = {
                                          value: d.name,
                                          score: d.score,
                                          color: d.color,
                                          comment: data.DetailEval[ic]?.comment,
                                          criteriaOptionValueIDs:
                                            data.DetailEval[ic]
                                              ?.criteriaOptionValueIDs,
                                          CriterionId: c.id,
                                          CriterionGroupeId: gc.id,
                                        };
                                        setData({
                                          ...data,
                                          DetailEval: [...data.DetailEval],
                                          // attributeIDs: "",
                                          // attributeValueIDs: "",
                                        });
                                      }
                                    }
                                    if (testSum.length === 0) {
                                      setTestSum([
                                        ...testSum,
                                        {
                                          score: d.score,
                                          id: c.id,
                                          impactant: c.impact,
                                          coefficient: c.coefficient,
                                          criteriaGroupeID: gc.id,
                                          NonApplicable: d.NonApplicable,
                                        },
                                      ]);
                                    } else {
                                      testSum.forEach((ob) => {
                                        if (ob.id !== c.id) {
                                          setTestSum([
                                            ...testSum,
                                            {
                                              score: d.score,
                                              id: c.id,
                                              impactant: c.impact,
                                              coefficient: c.coefficient,
                                              criteriaGroupeID: gc.id,
                                              NonApplicable: d.NonApplicable,
                                            },
                                          ]);
                                        } else {
                                          ob.score = d.score;
                                          ob.NonApplicable = d.NonApplicable;
                                        }
                                      });
                                    }

                                    setColorParam({
                                      id: d.id,
                                      color: d.color,
                                      name: d.name,
                                      value: d.score,
                                      comment: d.description,
                                    });
                                    setDisplayParam({
                                      statuse: !displayParam.status,
                                      idc: c.id,
                                      idg: gc.id,
                                    });
                                    !statuse[d.id]
                                      ? c.CriteriaValue.slice(
                                          0,
                                          idx + 1
                                        ).forEach((item, key) => {
                                          statuse[item.id] = true;
                                          color[item.id] = d.color;
                                        })
                                      : c.CriteriaValue.slice(idx + 1).forEach(
                                          (item, key) => {
                                            statuse[item.id] = false;
                                            color[item.id] = "none";
                                          }
                                        );

                                    setStatuse({ ...statuse });
                                    setColor({ ...color });

                                    statusgc[c.id] = d.score;
                                    c.CriteriaValue.slice(0, idx + 1).forEach(
                                      (item, key) => {
                                        statuse[item.id] = true;
                                        color[item.id] = d.color;
                                      }
                                    );
                                    setColor({ ...color });
                                    setStatusgc({ ...statusgc });

                                    if (sum[igc]) {
                                      if (
                                        gc?.Criteria?.map((e) => e.id).length >
                                        1
                                      ) {
                                        for (
                                          let i = 1;
                                          i <
                                          gc?.Criteria?.map((e) => e.id).length;
                                          i++
                                        ) {
                                          if (
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[i]
                                            ]
                                          ) {
                                            sum[igc] =
                                              statusgc[
                                                gc?.Criteria?.map(
                                                  (e) => e.id
                                                )[0]
                                              ] +
                                              statusgc[
                                                gc?.Criteria?.map((e) => e.id)[
                                                  i
                                                ]
                                              ];
                                          } else {
                                            sum[igc] =
                                              statusgc[
                                                gc?.Criteria?.map(
                                                  (e) => e.id
                                                )[0]
                                              ];
                                          }
                                        }
                                      } else {
                                        if (
                                          statusgc[
                                            gc?.Criteria?.map((e) => e.id)[1]
                                          ]
                                        ) {
                                          sum[igc] =
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[0]
                                            ] +
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[1]
                                            ];
                                        } else {
                                          sum[igc] =
                                            statusgc[
                                              gc?.Criteria?.map((e) => e.id)[0]
                                            ];
                                        }
                                      }
                                    } else {
                                      sum[igc] = statusgc[c.id];
                                    }

                                    setSum({ ...sum });

                                    sume[igc] = sum[igc];
                                    setSume({ ...sume });
                                  }}
                                >
                                  <span>{d.name}</span>

                                  {statuse[d.id] ? (
                                    <div
                                      style={{ backgroundColor: color[d.id] }}
                                      className="bar"
                                    ></div>
                                  ) : (
                                    <div className="bar"></div>
                                  )}
                                </div>
                              );
                            })}
                          
                          </div>

                          <div className="row right-icons">
                            <div className="col margin-left-right">
                              {displayCount &&
                              countoptions
                                .filter((cp) => cp.idC == c?.id)
                                .map((item) => item.idC)
                                .includes(c?.id) ? (
                                //  && countoptions.filter(cp => cp.idC == c?.id).map(item => item.count)[0] > 0
                                <div className="flex-space-between container-cercle-like">
                                  {
                                    countoptions
                                      .filter((cp) => cp.idC == c?.id)
                                      .map((item) => item.count)[0]
                                  }
                                </div>
                              ) : null}
                              <PopoverBonus
                                selectionOption={selectionOption}
                                getSelectionOption={getSelectionOption}
                                val={c?.CriteriaOption.filter(
                                  (e) => e?.type === "BONUS"
                                )}
                              />
                            </div>
                            <div className="col margin-left-right">
                              {displayCountMalus &&
                              countoptionsMalus
                                .filter((cp) => cp.idC == c?.id)
                                .map((item) => item.idC)
                                .includes(c?.id) ? (
                                // && countoptionsMalus.filter(cp => cp.idC == c?.id).map(item => item.count)[0] > 0
                                <div className="container-cercle-dislike">
                                  {
                                    countoptionsMalus
                                      .filter((cp) => cp.idC == c?.id)
                                      .map((item) => item.count)[0]
                                  }
                                </div>
                              ) : null}
                              <Popovermalus
                                selectionOption={selectionOptionMalus}
                                getSelectionOption={getSelectionOptionMalus}
                                val={c?.CriteriaOption.filter(
                                  (e) => e?.type === "MALUS"
                                )}
                              />
                            </div>
                            {isOpenComment.displayOpenComment &&
                            isOpenComment.id === ic ? (
                              <>
                                <div className="col margin-left-right">
                                  <div
                                    onClick={() => {
                                      setIsOpenComment({
                                        displayOpenComment: false,
                                        id: ic,
                                      });
                                      setCrId("");
                                      // showDescription();
                                    }}
                                  >
                                    <img
                                      className="img-chat-position"
                                      // width={20}
                                      alt=""
                                      src={iconChat}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="col margin-left-right">
                                <OverlayTrigger
                                  trigger="click"
                                  rootClose
                                  placement="bottom-end"
                                  overlay={popover}
                                >
                                  <img
                                    className="img-chat-position"
                                    // width={20}
                                    src={iconChat}
                                    alt=""
                                    onClick={() => {
                                      setIsOpenComment({
                                        displayOpenComment: false,
                                        id: ic,
                                      });
                                      //setCrId(c?.id);
                                      showDescription(c?.id);
                                    }}
                                  />
                                </OverlayTrigger>
                              </div>
                            )}

                            <div
                              onClick={() => {
                                displayInfoBar.displayInfoBar = true;
                                displayInfoBar.id = ic;
                                displayInfoBar.idg = igc;
                                setDisplayInfoBar({ ...displayInfoBar });
                                dispatch(getOneGrilles(datagrilleselecet?.grid?.id));
                              }}
                              // style={{ backgroundColor: "#FAFAFA" }}
                              className="col container-of-icon margin-left-right"
                            >
                              <img
                                className="img-chat-position"
                                alt=""
                                // width={25}
                                src={iconInfo}
                              />
                            </div>
                          </div>
                        
                        </div>
                      ))}
                    </div>
                  ))}
            </div>
            <div className="container-buttons_eval">
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "white",
                  borderColor: "#5800e2",
                  color: "#5800e2",
                  float: "right",
                }}
                onClick={() => {
                  history.goBack();
                  dispatch(HandelGrille({}));
                }}
              >
                Annuler
              </Button>
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "white",
                  borderColor: "gray",
                  color: "gray",
                  float: "right",
                }}
                disabled
              >
                Callibrer
              </Button>
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "#5800e2",
                  borderColor: "#5800e2",
                  float: "right",
                }}
                onClick={handleSubmit}
                disabled={isSaving}
              >
                {isSaving === true ? `Chargement ...` : `Enregistrer`}
              </Button>
            </div>
          </div>

          {displayInfoBar?.displayInfoBar ? (
            <div className="info-container">
              <div className="info-container-of-container">
                <div className="sub-bar-info-container">
                  <img
                    src={iconLeftArrow}
                    width="20"
                    height="20"
                    alt=""
                    onClick={() => {
                      displayInfoBar.displayInfoBar = false;
                      setDisplayInfoBar({ ...displayInfoBar });
                    }}
                  />
                  <span
                    style={{ marginBottom: "0" }}
                    className="info-subar-title"
                  >
                    {
                      datagrilleselecet?.grid?.CriteriaGroup[displayInfoBar?.idg]
                        ?.name
                    }
                  </span>
                </div>

                <>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="info-subar-subtitle">
                      {
                        datagrilleselecet?.grid?.CriteriaGroup[displayInfoBar.idg]
                          ?.Criteria[displayInfoBar.id]?.name
                      }
                    </span>
                    {/* <span className="info-subar-subsubtitle">
                      {" "}
                      Mesure de la phase d'acceuil{" "}
                    </span> */}
                  </div>
                  {datagrilleselecet?.grid?.CriteriaGroup[
                    displayInfoBar.idg
                  ].Criteria[displayInfoBar.id]?.CriteriaValue.map((e) => (
                    <div className="container-infos">
                      <span className="infos-subar-gc-title">{e.name} </span>
                      <span className="infos-subar-gc-text">
                        {" "}
                        {e.description}
                      </span>
                    </div>
                  ))}
                </>
              </div>
            </div>
          ) : null}
            
        </div>
        {showmessage && (
          <Alert
            message={"Il existe un critère obligatoire n’a pas été évalué."}
            status={"danger"}
            style={{ position: "absolute", bottom : 100}}
            display={display}
            onDisplay={onDisplay}
          />
        )}
        {showAgentmessage && (
          <Alert
            message={"Merci de sélectionner un agent."}
            status={"danger"}
            style={{ position: "absolute", bottom : 100}}
            display={display}
            onDisplay={onDisplay}
          />
        )}
          {showDatemessage && (
          <Alert
            message={"Merci de sélectionner une date."}
            status={"danger"}
            style={{ position: "absolute", bottom : 100}}
            display={display}
            onDisplay={onDisplay}
          />
        )}
        {message && (
          <Alert
            message={message}
            status={status === "error" ? "danger" : "success"}
            style={{ position: "absolute", bottom: 10, zIndex: 10000000 }}
            display={display}
            onDisplay={onDisplay}
          />
        )}
      </div>
    </>
  );
};

export default AddEval;
